import React, { Component } from 'react';
import Header from './Header'
import Footer from './Footer'
import './ShowCase.css'
import { Link } from 'react-router-dom'


class ShowCase extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    render() {
        return (
            <div className="showcase-page">
                <Header page={'Home'} />
                <section id="showcase">
                    <div className="mycontainer">
                        <h1>Great Self-service Express Asset Management</h1>
                        <p>Fully automatic express cabinet management allows users to check out and check in equipment easily</p>
                        <br/>
                        <Link className="btn1" to="/register"> {window.appLocale.messages['page.register'] || 'Register to use'}</Link>
                        <p></p>
                    </div>
                </section>
                <Footer />
            </div>
        );
    }
}

export default ShowCase;